<template>
  <div>
    <CRow>
      <CCol col>
        <CCard>
          <CCardHeader>
            <strong> Modulo de Cupon de Descuento - Editar</strong>
          </CCardHeader>
          <CCardBody>
            <b-form id="Form" @submit.prevent="Validate">
              <b-row>

                <b-col md="6">
                  <b-form-group label="Nombre:">
                    <b-form-input type="text" ref="name" v-model="discount_coupon.name" required placeholder="Ingrese su nombre"></b-form-input>
                    <small v-if="errors.name" class="form-text text-danger" >Ingrese un nombre o razón social</small>
                  </b-form-group>
                </b-col>

                <b-col md="2">
                  <b-form-group label="Tipo:">
                    <b-form-select v-model="discount_coupon.discount_type" :options="discount_type"></b-form-select>
                  </b-form-group>
                  <small v-if="errors.discount_type"  class="form-text text-danger" >Seleccione un tipo de descuento</small>
                </b-col>

                <b-col md="2">
                  <b-form-group label="Descuento:" required>
                    <b-form-input type="number" step="any" v-model="discount_coupon.discount"></b-form-input>
                    <small v-if="errors.discount" class="form-text text-danger" >Ingrese un descuento</small>
                  </b-form-group>
                </b-col>

      
                <b-col md="2">
                  <b-form-group label="Estado :">
                    <b-form-select  v-model="discount_coupon.state" :options="state"></b-form-select>
                  </b-form-group>
                </b-col>
         

                <b-col md="5"></b-col>
                <b-col md="2">
                  <b-button type="submit" class="form-control" variant="primary" ><i class="fas fa-save"></i> Guardar (F4)</b-button>
                </b-col>
              </b-row>
            </b-form>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
    <LoadingComponent :is-visible="isLoading"/>
    <Keypress key-event="keyup" :key-code="115" @success="Validate" />
  </div>
</template>

<script>
const axios = require("axios").default;
const Swal = require("sweetalert2");
const je = require("json-encrypt");
import { mapState } from "vuex";
import LoadingComponent from './../pages/Loading'
export default {
  name: "UsuarioAdd",
   props: ["id"],
  components:{
    Keypress: () => import('vue-keypress'),
      LoadingComponent,
  },
  data() {
    return {
      isLoading: false,
      module:'DiscountCoupon',
      discount_coupon: {
        id: "",
        name: "",
        descripcion: "",
        discount_type: "",
        discount: "",
        state: 1,
      },
      discount_type: [
        {value: '' , text : 'Seleccione un tipo'},
        {value: 'Porcentaje' , text : 'Porcentaje'},
        {value: 'Monto' , text : 'Monto'},
      ],
      state:[
        {value: 1 , text : 'Activo'},
        {value: 0 , text : 'Inactivo'},
      ],
      //errors
      errors: {
        name: false,
        discount_type: false,
        discount: false,
      },
      error_discount :'',
      validate: false,
    };
  },
  mounted() {
    this.viewDiscountCoupon();
  },
  methods: {
    viewDiscountCoupon,
    EditDiscountCoupon,
    Validate,
  },
  computed: {
    
    ...mapState(["url_base"]),
    token: function () {
      let user = window.localStorage.getItem("user");
      user = JSON.parse(JSON.parse(je.decrypt(user)));
      return user.api_token;
    },
  },
};

function viewDiscountCoupon() {
  let me = this;
  me.isLoading = true;
  let id = je.decrypt(me.id);
  let url = me.url_base + "discount-coupons/view/" + id;
  axios({
    method: "GET",
    url: url,
    headers: { token: me.token, module: me.module, role: 3},
  })
    .then(function (response) {
      if (response.data.status == 200) {
        me.discount_coupon.id = response.data.result.id;
        me.discount_coupon.name = response.data.result.name;
        me.discount_coupon.discount_type = response.data.result.discount_type;
        me.discount_coupon.discount = response.data.result.discount;
        me.discount_coupon.state = response.data.result.state;

      } else {
        Swal.fire({ icon: 'error', text: 'A ocurrido un error', timer: 3000,})
      }
      me.isLoading = false;
    })
  
}


function EditDiscountCoupon() {
  
  let me = this;
  let url = me.url_base + "discount-coupons/edit";
  let data = me.discount_coupon;
  me.isLoading = true;
  axios({
    method: "PUT",
    url: url,
    data: data,
    headers: { "Content-Type": "application/json", token: me.token, module: me.module, role: 2,},
  })
    .then(function (response) {
      if (response.data.status == 200) {
        Swal.fire({ icon: 'success', text: 'Se ha actualizado el cupon descuento', timer: 3000,})
      } else {
        Swal.fire({ icon: 'error', text: 'A ocurrido un error', timer: 3000,})
      }
      me.isLoading = false;
    })
    .catch((error) => {
      Swal.fire({ icon: 'error', text: 'A ocurrido un error', timer: 3000,})
      me.isLoading = false;
    });
}

function Validate() {
  this.validate = false;
  this.errors.name = this.discount_coupon.name.length == 0 ? true : false;
  this.errors.discount_type = this.discount_coupon.discount_type.length == 0 ? true : false;
  this.errors.discount = this.discount_coupon.discount.length == 0 ? true : false;

  if (this.errors.name) { this.validate = true; Swal.fire({ icon: 'warning', text: 'Verifique que campos necesarios esten llenados', timer: 2000,}); return false;}else{ this.validate = false; }
  if (this.errors.discount_type) { this.validate = true; Swal.fire({ icon: 'warning', text: 'Verifique que campos necesarios esten llenados', timer: 2000,}); return false;}else{ this.validate = false; }
  if (this.errors.discount) { this.validate = true; Swal.fire({ icon: 'warning', text: 'Verifique que campos necesarios esten llenados', timer: 2000,}); return false;}else{ this.validate = false; }
  if (!this.validate) {
    Swal.fire({
      title: "Esta seguro de actualizar el cupon descuento?",
      text: "",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Si, Estoy de acuerdo!",
    }).then((result) => {
      if (result.value) {
        this.EditDiscountCoupon();
      }
    });

  }

}
</script>
